import axios from "axios"
import library from "../../../utils/Library"

export const createSubscriptionDelegationVE = async (newData) => {
  const TOKEN = sessionStorage.getItem("token")

  const URL =
    library.getBaseAPIUrl("legal_communications") +
    "/createSubscriptionDelegationVE"

  return await axios(URL, {
    url: URL,
    method: "POST",
    data: newData,
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
